// import { StrictMode } from "react";
// import { createRoot } from "react-dom/client";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import "./index.css";
// import "@fontsource/inter";
// import App from "./App.jsx";
// import ResultPage from "./pages/ResultPage.jsx";
// import OverviewPage from "./pages/OverviewPage.jsx";
// import { Analytics } from "@vercel/analytics/react";
// import ContactUs from "./pages/Contactus.jsx";
// import AddCompanyPage from "./pages/AddCompanyPage.jsx";
// import FAQPage from "./pages/FAQPage.jsx";
// import CityResultsPage from "./pages/CityResultsPage.jsx";
// import SitemapPage from "./pages/SitemapPage.jsx";
// import CityFooterPage from "./pages/CityFooterPage.jsx";
// import CountrySearch from "./pages/CountrySeachPage.jsx";

// createRoot(document.getElementById("root")).render(
//   <Router>
//     <Analytics />
//     <Routes>
//       <Route Component={App} path="/" />
//       <Route Component={CountrySearch} path="/:country" />
//       <Route Component={CityFooterPage} path="/city" />
//       <Route
//         Component={OverviewPage}
//         path="/:country/:category/:company_name"
//       />
//       <Route
//         Component={CityResultsPage}
//         path="/:country/:city/:category"
//       />
//       <Route Component={ResultPage} path="/:country/:cityOrCategory" />
//       <Route Component={ContactUs} path="/contact_us" />
//       <Route Component={AddCompanyPage} path="/add_company" />
//       <Route Component={FAQPage} path="/faqs" />
//       <Route Component={SitemapPage} path="/sitemap" />
//     </Routes>
//   </Router>
// );


import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Routes, Route, useParams } from "react-router-dom";
import "./index.css";
import "@fontsource/inter";
import App from "./App.jsx";
import ResultPage from "./pages/ResultPage.jsx";
import OverviewPage from "./pages/OverviewPage.jsx";
import AddCompanyPage from "./pages/AddCompanyPage.jsx";
import FAQPage from "./pages/FAQPage.jsx";
import CityResultsPage from "./pages/CityResultsPage.jsx";
import SitemapPage from "./pages/SitemapCountryPage.jsx";
import CityFooterPage from "./pages/CityFooterPage.jsx";
import CountrySearch from "./pages/CountrySeachPage.jsx";
import SitemapCountryPage from "./pages/SitemapPage.jsx";
import ContactusPage from "./pages/ContactusPage.jsx";
import ThankyouPage from "./pages/ThankyouPage.jsx";

// Custom Route Component to handle conflicts
function CustomRoute() {
  const { cityOrCategory, categoryOrCompany } = useParams();

  if (categoryOrCompany) {
    if (cityOrCategory && !categoryOrCompany.includes("-")) {
      // When `categoryOrCompany` doesn't look like a company name
      return <CityResultsPage />;
    } else {
      // When `categoryOrCompany` looks like a company name
      return <OverviewPage />;
    }
  }
}

createRoot(document.getElementById("root")).render(
  <Router>
    <Routes>
      {/* Handle the dynamic case with custom logic */}
      <Route path="/:country/:cityOrCategory/:categoryOrCompany" element={<CustomRoute />} />

      {/* Other routes */}
      <Route Component={ResultPage} path="/:country/:cityOrCategory" />
      <Route path="/:country" Component={CountrySearch} />
      <Route path="/city" Component={CityFooterPage} />
      <Route path="/contact_us" Component={ContactusPage} />
      <Route path="/add_company" Component={AddCompanyPage} />
      <Route path="/faqs" Component={FAQPage} />
      <Route path="/sitemap/" Component={SitemapPage} />
      <Route path="/sitemap/:country" Component={SitemapCountryPage} />
      <Route path="/thankyou" Component={ThankyouPage}/>
      <Route path="/" Component={App} />
    </Routes>
  </Router>
);